import { render, staticRenderFns } from "./Shedule.vue?vue&type=template&id=d4763ca8&scoped=true&"
import script from "./Shedule.vue?vue&type=script&lang=js&"
export * from "./Shedule.vue?vue&type=script&lang=js&"
import style0 from "./Shedule.vue?vue&type=style&index=0&id=d4763ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4763ca8",
  null
  
)

export default component.exports